export default "__VITE_ASSET__CRBUD8uS__"